import React from "react";
import { Icon } from "@iconify/react";
import DataManagement from "../../components/table/DataManagement.jsx";
import { Link } from "react-router-dom";

import { usePagos } from "../../hooks_cache/usePagos.js";

const columns = [
  {
    accessorKey: "id",
    header: "ID",
    cell: ({ getValue }) => <Link to={`/venta/pago?id_pago=${getValue()}`}>PAGO-{getValue()}</Link>,
  },
  { accessorKey: "fecha_pago", header: "Fecha Pago" },
  { accessorKey: "Tercero.nombre", header: "Tercero" },
  { accessorKey: "TipoPago.descripcion", header: "Tipo Pago" },
  { accessorKey: "referencia", header: "Referencia" },
  { accessorKey: "User.name", header: "Creado por" },
  {
    accessorKey: "monto",
    header: "Monto",
    cell: ({ getValue }) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(getValue()),
  },
];

function PagosRecibidos() {
  const { data: pagos, refetch } = usePagos();

  return (
    <DataManagement
      columns={columns}
      data={pagos}
      title="Pagos Recibidos"
      enableRowSelection={false}
      actions={[
        <button onClick={refetch} className="btn btn-theme btn-sm d-flex pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Refrescar tabla
        </button>,
      ]}
    />
  );
}

export default PagosRecibidos;
